import createAsyncRequest from '@framework/state/createAsyncRequest';
import createAction from '@framework/state/createAction';
import * as actionTypes from './actionTypes';
import EvercallCallFormRepository from '../infrastructure/repository/EvercallCallFormRepository';
import { getContainer } from '@framework/di/getContainer';
import { useTimeZoneContext } from '@framework/timezone/TimeZoneContext';

export default (state, dispatch) => {
  const container = getContainer();
  const { getTimeZoneList } = useTimeZoneContext();
  const evercallRepository: EvercallCallFormRepository = container.get(EvercallCallFormRepository);

  const getCallFormLists = () => {
    const method = () => Promise.all(
      [
        evercallRepository.getTransactionTypes(),
        evercallRepository.getDialInCountries(),
        evercallRepository.getPlatformList(),
        getTimeZoneList({ shouldHandleError: false }),
      ],
    );
    const request = createAsyncRequest<typeof method>(
      {
        dispatch,
        method,
        types: [
          actionTypes.GET_CALL_FORM_LISTS,
          actionTypes.GET_CALL_FORM_LISTS_SUCCESS,
          actionTypes.GET_CALL_FORM_LISTS_ERROR,
        ],
      },
    );
    return request();
  };

  const setIsSubmitting = (payload) => dispatch(createAction(actionTypes.SET_IS_SUBMITTING, payload));
  const setIsInitialized = (payload) => dispatch(createAction(actionTypes.SET_IS_INITIALIZED, payload));
  const setIsSubmitSucceeded = (payload) => dispatch(createAction(actionTypes.SET_IS_SUBMIT_SUCCEEDED, payload));

  return {
    getCallFormLists,
    setIsSubmitting,
    setIsInitialized,
    setIsSubmitSucceeded,
  };
};
